import React, { Component } from "react";
import { withRouter } from "react-router";

import {
  FormGroup,
  Row,
  Col,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormFeedback
} from "reactstrap";
import withReactContent from "sweetalert2-react-content";
import api from "../../utils/axiosApi";
import { Toast } from "../../utils/sweetalert";
import { emailSchema, nameSchema, passwordSchema } from "../../utils/validateForm";


class Forms extends Component {
  constructor(props) {
    super(props) 
    this.state = {
      name : '',
      email : '',
      password : '',
      repassword: '',
      level: 'admin',
      errors : {
        name : false,
        email : false,
        password : false,
        newPassword: false,
      }
    }
  }
  handleSubmit = async (e) =>{
    e.preventDefault()
    const passwordValidation = passwordSchema.validate(this.state.password);
        const emailValidation = emailSchema.validate(this.state.email);
        const nameValidation = nameSchema.validate(this.state.name)
        let newStateError = {...this.state.errors}
        if (emailValidation.error) {
            
            newStateError = {...newStateError, email: '*Email No Valido'}
        }
        if (nameValidation.error) {
            newStateError = {...newStateError, name: '*Password No Valida'}
        }
        if (passwordValidation.error || this.state.password !== this.state.repassword) {
            
            newStateError = {...newStateError, password: '*Email No Valido'}
        }
        this.setState({errors: newStateError})
         if(passwordValidation.error || emailValidation.error || nameValidation.error) {return}
         try {
          await api.post(`/user/signup`, {
            name: this.state.name,
            email: this.state.email,
            password: this.state.password,
            repassword: this.state.repassword,
            level: this.state.level,
            remenber: false
          })
          this.props.history.push('/admin/VerAdmins')
          const MySwal = withReactContent(Toast)
            await MySwal.fire({
                title: <p style={{fontSize: '1.5rem'}}>Admin creado Exitosamente</p>,
                icon: 'success',
                
            })
         } catch (error) {
           //console.log(error)
           const MySwal = withReactContent(Toast)
            await MySwal.fire({
                title: <p style={{fontSize: '1.5rem'}}>algo salio Mal...</p>,
                icon: 'error',
                
            })
         }
    
  }
  handleChange = (e) => {
    const value = e.target.value.toLowerCase()
    this.setState({[e.target.name]: value})
  }
  handleChangePassword = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }
  handleValidateEmail =(e) =>{
    const validation = emailSchema.validate(this.state.email)
        if(validation.error) {
            this.setState({errors: {...this.state.errors, email: true}})
        } else {
            this.setState({errors: {...this.state.errors, email: false}})
        }
  }
  handleValidateName =(e) =>{
    const validation = nameSchema.validate(this.state.name)
        if(validation.error) {
            this.setState({errors: {...this.state.errors, name: true}})
        } else {
            this.setState({errors: {...this.state.errors, name: false}})
        }
  }
  handleValidatePassword =(e) =>{
    const validation = passwordSchema.validate(this.state.password)
        if(validation.error || this.state.password !== this.state.repassword) {
            this.setState({errors: {...this.state.errors, password: true}})
        } else {
            this.setState({errors: {...this.state.errors, password: false}})
        }
  }
  render() {
    return (
      <>
      <div className="content">
        <Row>
          <Col md="12">
          <Card>
          <CardHeader>
          <CardTitle tag="h4">Crear Admin</CardTitle>
          </CardHeader>
      <CardBody>
        <form onSubmit={this.handleSubmit}>
          <FormGroup>
            <Label for="name">Nombre Del Admin</Label>
            <Input
              onChange={this.handleChange}
              onBlur={this.handleValidateName}
              invalid={this.state.errors.name}
              type="text"
              name="name"
              id="name"
              placeholder="Introduzca el nombre"
            />
            <FormFeedback>El nombre no es Valido</FormFeedback>
          </FormGroup>
          <FormGroup>
            <Label for="email">Correo</Label>
            <Input
              onChange={this.handleChange}
              onBlur={this.handleValidateEmail}
              invalid={this.state.errors.email}
              type="email"
              name="email"
              id="email"
              placeholder="Introduzca el Email"
            />
            <FormFeedback>El correo no es Valido</FormFeedback>
          </FormGroup>
          <Row>
                    <Col className="pr-md-1" md="6">
                    <FormGroup>
                      <Label for="password">Contraseña</Label>
                      <Input
                        onChange={this.handleChangePassword}
                        onBlur={this.handleValidatePassword}
                        invalid={this.state.errors.password}
                        type="password"
                        name="password"
                        id="exampleEmail"
                        placeholder="Min 8 caracteres"
                      />
                      <FormFeedback>la contraseña no es Valida</FormFeedback>
                    </FormGroup>
                    </Col>
                    <Col className="pl-md-1" md="6">
                    <FormGroup >
                      <Label for="repassword">Repita la Contraseña</Label>
                      <Input
                        onChange={this.handleChangePassword}
                        onBlur={this.handleValidatePassword}
                        invalid={this.state.errors.password}
                        type="password"
                        name="repassword"
                        id="repassword"
                        placeholder="Vuelva a ingresar la contraseña"
                      />
                    </FormGroup>
                    </Col>
                    
                  </Row>
          
          
          <Button color="primary" type="submit">
            Crear Admin
          </Button>
        </form>
      </CardBody>
    </Card>
          </Col>
        </Row>
      </div>
    </>
    )
  }
}


export default withRouter(Forms);
